@if (isLoadingRequest === false) {
  <div class="grid form-group">
    <addbasefile
      [visible]="visible"
      [displayStopValue]="displayStop"
      [uploader]="uploader"
      [title]="'Doc_Add' | translate"
      [dataLabel]="bskLabel"
      [bskType]="bskType"
      [bskDocAddList]="bskDocAddList"
      [ctrlDouble]="ctrlDouble"
      [enterVariable]="enterVariable"
      [requiredVariable]="requiredVariable"
      [fileMode]="true"
      [disabledSend]="disabledSend"
      (onClose)="close($event)"
      (onClickAdd)="onClickAdd($event)"
      (onClickStop)="onClickStop($event)"
      (onSetIndex)="clickSetIndex($event)"
      (onRemoveItem)="removeItem($event)"
    ></addbasefile>
  </div>
}

@if (displayIndex === true) {
  <p-dialog
    [contentStyle]="{'max-width': '55vw' }"
    [styleClass]="'sm:col-12 md:col-12 lg:col-7 xl:col-6'"
    [(visible)]="displayIndex"
    [modal]="true"
    [closable]="true"
    >
    <ng-template pTemplate="header">
      <div class="word-break">
        {{'File' | translate}} {{ currentFile }}, {{'Basket' | translate}} {{bskLabel}}
      </div>
    </ng-template>
    @if (bskType === 'btMail') {
      <div class="col-12">
        <infosmail [visuMode]="false" [bskTypeMail]="true" [editMode]="true" [infosMailDisplay]="currentInfosMail"></infosmail>
      </div>
    }
    <div class="col-12 scroll-table">
      <inputvalue
        [visuMode]="false"
        [title]="'Index_B' | translate"
        [dataVariableList]="bskDocAddList[currentIndex].varList"
        [libAction]="false"
        [editorService]="bskDocAddList[currentIndex].editorService"
        >
      </inputvalue>
    </div>
    <div class="col-12 md:col-12 align-right">
      @if (
        bskDocAddList[currentIndex].varList.length !== 0 && bskDocAddList[currentIndex].saveIndex === false
        ) {
        <button
          type="button"
          pButton
          class="margin"
          (click)="onClickSaveOther()"
          label="{{'Doc_NotE' | translate}}"
        ></button>
      }
      @if (
        bskDocAddList[currentIndex].varList.length === 0 &&
        bskDocAddList[currentIndex].saveIndex === false &&
        bskType === 'btMail'
        ) {
        <button
          type="button"
          pButton
          class="margin"
          (click)="onClickSaveOther()"
          label="{{'Doc_NotE' | translate}}"
        ></button>
      }
      <button type="button" pButton class="margin p-button-primary p-button-outlined" (click)="closeIndex()" label="{{'Cancel' | translate}}"></button>
      @if (bskDocAddList[currentIndex].varList.length !== 0) {
        <button
          type="button"
          pButton
          class="margin"
          (click)="onClickSaveIndex()"
          label="{{'Save' | translate}}"
        ></button>
      }
      @if (bskDocAddList[currentIndex].varList.length === 0 && bskType === 'btMail') {
        <button
          type="button"
          pButton
          class="margin"
          (click)="onClickSaveIndex()"
          label="{{'Save' | translate}}"
        ></button>
      }
    </div>
  </p-dialog>
}

